export class AccessDataFromToken {
    contactFirstName: string;
    contactLastName: string;
    contactEmail: string;
    contactGender: string;
    jobId:string;
    profesionalPhone: string;
    mobilePhone: string;
    companyGLN: string;
    companyName: string;
    companySiren: string;
    companyVatIntra: string;
    companyNaf: string;
    contactId: string;
    companyId: string;
    companyAddress: CompanyAddressInfo;
    contactAddress: ContactAddressInfo;
    contact_info: any;
    email: string;
    privileges : any;
    constructor(tokenData: any) {
        /* const contactInfo = JSON.parse(tokenData.contact_info);
        this.contactFirstName = contactInfo.FirstName;
        this.contactLastName = contactInfo.LastName;
        this.contactGender=contactInfo.Gender;
        this.jobId=contactInfo.JobId;
        this.profesionalPhone=contactInfo.ProfessionalPhone; */
        this.contactEmail = tokenData.email;
       // this.mobilePhone = contactInfo.MobilePhone;
        this.companyGLN = tokenData.company_gln;
        this.companyName = tokenData.company_name;
        this.companySiren = tokenData.company_siren;
        this.companyVatIntra = tokenData.company_vatIntra;
        this.companyNaf = tokenData.company_naf;
        this.contactId = tokenData.contact_id;
        this.companyId = tokenData.company_id;
        this.privileges = tokenData.privileges;
        //this.companyAddress = new CompanyAddressInfo(contactInfo.Addresses[0]);
        //this.contactAddress = new ContactAddressInfo(contactInfo.Addresses[0]);
    }
}

export class CompanyAddressInfo {
    countryCode: string;
    postalCode: string;
    address: string;
    city: string;

    constructor(addressData: any) {
        this.countryCode = addressData.Country;
        this.postalCode = addressData.PostalCode;
        this.address = addressData.Street;
        this.city = addressData.City;
    }
}

export class ContactAddressInfo {
    countryCode: string;
    postalCode: string;
    address: string;
    city: string;

    constructor(addressData: any) {
        this.countryCode = addressData.Country;
        this.postalCode = addressData.PostalCode;
        this.address = addressData.Street;
        this.city = addressData.City;
    }
}